export function addRegionToSemanticUrl(semanticUrl: string, backupUrl: string, region: string, queryString?: string) {
  let fullUrl = backupUrl;
  let pathName = backupUrl;
  let otherQuery = queryString || '';
  if (semanticUrl) {
    const trimUrl = semanticUrl.split('?')[0];
    pathName = trimUrl.replace(/^https:\/\/(m.|www.)?(lemon8-app|sharee).com/, '');
  }
  fullUrl = `${pathName}?region=${region}`;
  const canonicalUrl = `${pathName}?region=${region}`;
  if (queryString) {
    if (queryString.startsWith('?')) {
      // eslint-disable-next-line prefer-destructuring
      otherQuery = queryString.split('?')[1];
    }
    fullUrl += `&${otherQuery}`;
  }
  return {
    fullUrl,
    pathName,
    canonicalUrl,
  };
}
